import { PayLevel, UiScroll } from 'components';
import styled from 'styled-components';

const Wrap = styled.div`
  position: absolute;
  left: 305px;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #282e36;
  z-index: 10;
  color: #fff;
  font-size: 14px;
  .hd {
    font-size: 18px;
    font-weight: 500;
    height: 72px;
    box-sizing: border-box;
    padding: 32px 0 20px;
    line-height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    &__back {
      position: absolute;
      left: 16px;
      font-size: 32px;
      font-weight: normal;
      cursor: pointer;
    }
  }

  .bd {
    height: 380px;
  }

  .desc {
    padding: 0 28px;
    font-size: 14px;
    color: #c3c3c3;
    span {
      color: #8955f7;
    }
  }
`;

const ItemStyled = styled.div`
  display: flex;
  align-items: center;
  width: 420px;
  height: 76px;
  background: #3e454d;
  border-radius: 4px;
  margin: 12px auto;
  padding: 0 12px;
  box-sizing: border-box;
  border: solid 1px transparent;
  cursor: pointer;

  .text-overflow {
    color: var(--color-primary);
    font-size: 14px;
    font-weight: 500;
    max-width: 10em;
  }

  img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-right: 12px;
  }

  .item__id {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    background: rgba(137, 85, 247, 0.3);
    padding: 0 4px;
    line-height: 14px;
    display: inline-block;
    vertical-align: middle;
  }

  .item__login-time {
    font-size: 12px;
    font-weight: normal;
    line-height: 15px;
    letter-spacing: 0px;
    color: #8d91a4;
  }

  &:hover,
  &.item--active {
    background: rgba(137, 85, 247, 0.2);
    border: 1px solid #8955f7;
  }
`;

// 1天以内显示具体时间xx:xx:xx；1年以内显示xx天前；1年以上统一 显示1年前
const Item = (props) => {
  // item--active
  const { item, onSelect } = props;

  const handleSelect = () => {
    onSelect(item);
  };

  return (
    <ItemStyled className="" onClick={handleSelect}>
      <img src={item.avatar} alt="" />
      <div className="flex-auto">
        <div className="text-overflow">{item.nickname}</div>
        <div>
          <PayLevel level={item.vip_level}></PayLevel>
          <span className="item__id">ID：{item.id}</span>
        </div>
      </div>
      <div className="item__login-time">上次登录：{item.last_login_text}</div>
    </ItemStyled>
  );
};

const MobileLoginSelect = (props) => {
  const { accounts, mobile, onSelect, onBack } = props;
  return (
    <Wrap>
      <div className="hd">
        <span className="hd__back iconfont icon-arrow-left" onClick={onBack}></span>
        <span>请选择登录账号</span>
      </div>

      <UiScroll overflowY className="bd">
        <div className="desc">
          您的手机号 <span>{mobile.replace(/(\d{3})(\d{4})(\d{4})/, '$1 **** $3')}</span>{' '}
          关联了多个账号，请选择需要登录账号
        </div>
        {accounts.map((item, index) => {
          return <Item key={item.id} item={item} onSelect={onSelect}></Item>;
        })}
      </UiScroll>
    </Wrap>
  );
};

export default MobileLoginSelect;
